import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  class: "app",
  id: "root"
}
const _hoisted_2 = {
  key: 0,
  class: "app-global-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-info"
}

import { reactive, provide } from 'vue';
import ContextView from './ContextView.vue';
import spinnerBallGridPulse from './spinners/spinner-ball-grid-pulse.vue';
import { dictionaryServiceFactory } from './lib/dictionary-service-factory';
import { webStorage } from '@/utils/web-storage';
import { S_I18N } from '@/utils/web-storage-keys';
import { APP_CONST } from '@/utils/constants';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppRoot',
  setup(__props) {

const i18n = useI18n();
const state = reactive({
  languageIsChanging: false,
  contextViewVisible: false,
  globalLoadingVisible: false,
});
const changeAppLanguage = async (language: string) => {
  if (!i18n) {
    // console.error('i18n instance is not initialized');
    return;
  }
  APP_CONST.lang = language;
  if (i18n.locale.value !== language) {
    // Changing languages is an async action, therefore the `languageIsChanging` property can be used
    // to show a loading/switching screen when language is being changed.
    state.languageIsChanging = true;
    try {
      const cache = webStorage.get(S_I18N) || {};
      if (!cache[language] || cache[language].length === 0) {
        // create an instance of the dictionary service
        const dictionaryServiceInstance = dictionaryServiceFactory.create();
        cache[language] = await dictionaryServiceInstance.fetchDictionaryData(language);
        webStorage.set(S_I18N, cache);
      }
      i18n.mergeLocaleMessage(language, cache[language]);
      i18n.locale.value = language;
    } catch (error) {
      console.error('Error changing language:', error);
    } finally {
      state.languageIsChanging = false;
    }
  }
};
const toggleContextView = () => {
  state.contextViewVisible = !state.contextViewVisible;
};
const showGlobalLoading = () => {
  state.globalLoadingVisible = true;
};
const hideGlobalLoading = () => {
  state.globalLoadingVisible = false;
};
provide('languageIsChanging', state.languageIsChanging);
provide('changeAppLanguage', changeAppLanguage);
provide('toggleContextView', toggleContextView);
provide('showGlobalLoading', showGlobalLoading);
provide('hideGlobalLoading', hideGlobalLoading);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ContextView, {
      visible: state.contextViewVisible
    }, null, 8, ["visible"]),
    (state.globalLoadingVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(spinnerBallGridPulse)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (state.languageIsChanging)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Language is changing..."))
      : _createCommentVNode("", true)
  ]))
}
}

})